import { createSlice } from '@reduxjs/toolkit';
import type { WorkspaceState } from './interfaces';
import { sharedActions } from './shared-actions';

const initialState: WorkspaceState = {
  group: {
    entity: {
      id: 0,
    },
    object: {
      id: 0,
      name: '',
    },
  },
  personal: {
    entity: {
      id: 0,
    },
    object: {
      id: 0,
      name: '',
    },
  },
};

export const workspaceSlice = createSlice({
  name: 'workspaces',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sharedActions.appStateLoaded, (_, action) => {
      return action.payload.workspace;
    });
    builder.addCase(sharedActions.userLoggedOutAction, () => {
      return initialState;
    });
  },
});

export default workspaceSlice.reducer;
